var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4aa5ff",
    d: "M8.016 28.475h10v12h-12v-10a2 2 0 0 1 2-2z",
    opacity: 1,
    "data-original": "#4aa5ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21257c",
    d: "M18.016 41.475h-12a1 1 0 0 1-1-1v-10c0-1.654 1.346-3 3-3h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1zm-11-2h10v-10h-9a1 1 0 0 0-1 1z",
    opacity: 1,
    "data-original": "#21257c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6f3ff",
    d: "M7.016 40.475h11v12h-13v-10a2 2 0 0 1 2-2z",
    opacity: 1,
    "data-original": "#e6f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21257c",
    d: "M18.016 53.475h-13a1 1 0 0 1-1-1v-10c0-1.654 1.346-3 3-3h11a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1zm-12-2h11v-10h-10a1 1 0 0 0-1 1z",
    opacity: 1,
    "data-original": "#21257c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4aa5ff",
    d: "M18.016 45.475h-8c-1.312-.02-1.316-1.978 0-2h8c1.312.021 1.316 1.979 0 2zM18.016 49.475h-8c-1.312-.02-1.316-1.978 0-2h8c1.312.021 1.316 1.979 0 2z",
    opacity: 1,
    "data-original": "#4aa5ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6f3ff",
    d: "M10.016 32.475h8v4h-8z",
    opacity: 1,
    "data-original": "#e6f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6f3ff",
    d: "M18.016 37.475h-8a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1zm-7-2h6v-2h-6z",
    opacity: 1,
    "data-original": "#e6f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6f3ff",
    d: "M18.016 24.646h28v27.83h-28z",
    opacity: 1,
    "data-original": "#e6f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4aa5ff",
    d: "M46.016 23.475c-1.064-6.875-7.043-12-14-12-7.22-.03-13.887 5.824-14 13.17h28zM58.516 57.475h-53a2.5 2.5 0 0 1 0-5h53c3.28.078 3.31 4.914 0 5z",
    opacity: 1,
    "data-original": "#4aa5ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21257c",
    d: "M58.516 58.475h-53c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5h53c4.61.14 4.638 6.85 0 7zm-53-5c-1.953.03-1.986 2.964 0 3h53a1.501 1.501 0 0 0 0-3h-53z",
    opacity: 1,
    "data-original": "#21257c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21257c",
    d: "M46.016 53.475h-28a1 1 0 0 1-1-1c.032-.169-.037-29.007.012-29.153 3.08-17.018 26.895-17.023 29.976 0 .058.104-.017 29.025.012 29.154a1 1 0 0 1-1 1zm-27-2h26V23.553c-1.017-6.32-6.592-11.078-13-11.078s-11.983 4.757-13 11.078z",
    opacity: 1,
    "data-original": "#21257c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21257c",
    d: "M46.016 25.475h-28c-1.305-.019-1.322-1.977 0-2h28c1.305.02 1.322 1.978 0 2z",
    opacity: 1,
    "data-original": "#21257c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4aa5ff",
    d: "M23.016 24.475h8v28h-8z",
    opacity: 1,
    "data-original": "#4aa5ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21257c",
    d: "M31.016 53.475h-8a1 1 0 0 1-1-1v-28a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v28a1 1 0 0 1-1 1zm-7-2h6v-26h-6z",
    opacity: 1,
    "data-original": "#21257c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21257c",
    d: "M31.016 29.475h-8c-1.312-.02-1.316-1.978 0-2h8c1.312.021 1.316 1.979 0 2zM31.016 34.475h-8c-1.312-.02-1.316-1.978 0-2h8c1.312.021 1.316 1.979 0 2zM31.016 40.475h-8c-1.312-.02-1.316-1.978 0-2h8c1.312.021 1.316 1.979 0 2zM31.016 47.475h-8c-1.312-.02-1.316-1.978 0-2h8c1.312.021 1.316 1.979 0 2z",
    opacity: 1,
    "data-original": "#21257c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4aa5ff",
    d: "M59.016 14.975a8.5 8.5 0 1 0-17 0v1.947h17z",
    opacity: 1,
    "data-original": "#4aa5ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6f3ff",
    d: "M42.016 16.922h17v35.553h-17z",
    opacity: 1,
    "data-original": "#e6f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21257c",
    d: "M59.016 53.475h-17a1 1 0 0 1-1-1v-37.5c.517-12.592 18.476-12.61 19 0v37.5a1 1 0 0 1-1 1zm-16-2h15v-36.5c0-4.135-3.364-7.5-7.5-7.5s-7.5 3.365-7.5 7.5z",
    opacity: 1,
    "data-original": "#21257c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21257c",
    d: "M59.016 18.475h-17c-1.31-.02-1.319-1.978 0-2h17c1.31.02 1.319 1.978 0 2z",
    opacity: 1,
    "data-original": "#21257c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4aa5ff",
    d: "M51.016 17.475h4v35h-4z",
    opacity: 1,
    "data-original": "#4aa5ff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#21257c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.016 53.475h-4a1 1 0 0 1-1-1v-35a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v35a1 1 0 0 1-1 1zm-3-2h2v-33h-2z",
    fill: "#21257c",
    opacity: 1,
    "data-original": "#21257c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.016 22.475h-4c-1.313-.021-1.315-1.978 0-2h4c1.313.022 1.315 1.979 0 2zM55.016 27.475h-4c-1.313-.021-1.315-1.978 0-2h4c1.313.022 1.315 1.979 0 2zM55.016 33.475h-4c-1.313-.021-1.315-1.978 0-2h4c1.313.022 1.315 1.979 0 2zM55.016 40.475h-4c-1.313-.021-1.315-1.978 0-2h4c1.313.022 1.315 1.979 0 2zM55.016 48.475h-4c-1.313-.021-1.315-1.978 0-2h4c1.313.022 1.315 1.979 0 2z",
    fill: "#21257c",
    opacity: 1,
    "data-original": "#21257c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterStorage);
export default __webpack_public_path__ + "static/media/waterStorage.75577e4dd09887caeccd5971f13c702e.svg";
export { ForwardRef as ReactComponent };